module.exports = __webpack_public_path__ + "static/media/logo.b6b42ba1.png";